export var getMaxApplePayVersion = function () {
    var version = 15;
    while (version > 0) {
        if (ApplePaySession.supportsVersion(version)) {
            return version;
        }
        version -= 1;
    }
    return version;
};
